"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTooltipStyles = void 0;
const leftTopArrowStyles = {
    top: 0,
    left: 0,
    // @ts-ignore
    borderBottomLeftRadius: "1px",
    transform: "translateX(-40%) translateY(10px) rotate(45deg)",
    // @ts-ignore
    boxShadow: "0px 0px 2px 0px rgba(0, 0, 0, 0.12)"
};
const leftCenterArrowStyles = {
    top: "50%",
    left: 0,
    transform: "translate(-40%, -50%) rotate(45deg)",
    // @ts-ignore
    borderBottomLeftRadius: "1px",
    transformOrigin: "center center",
    // @ts-ignore
    boxShadow: "0px 0px 2px 0px rgba(0, 0, 0, 0.12)"
};
const leftBottomArrowStyles = {
    bottom: 0,
    left: 0,
    // @ts-ignore
    borderBottomLeftRadius: "1px",
    transform: "translateX(-40%) translateY(-10px) rotate(45deg)",
    // @ts-ignore
    boxShadow: "0px 0px 2px 0px rgba(0, 0, 0, 0.12)"
};
const topStartArrowStyles = {
    top: 0,
    left: 0,
    // @ts-ignore
    borderTopLeftRadius: "1px",
    transform: "translateY(-40%) translateX(10px) rotate(45deg)",
    // @ts-ignore
    boxShadow: "0px 0px 2px 0px rgba(0, 0, 0, 0.12)"
};
const topCenterArrowStyles = {
    top: 0,
    left: "50%",
    transform: "translate(-50%, -40%) rotate(45deg)",
    // @ts-ignore
    borderTopLeftRadius: "1px",
    transformOrigin: "center center",
    // @ts-ignore
    boxShadow: "0px 0px 2px 0px rgba(0, 0, 0, 0.12)"
};
const topEndArrowStyles = {
    top: 0,
    right: 0,
    // @ts-ignore
    borderTopLeftRadius: "1px",
    transform: "translateY(-40%) translateX(-10px) rotate(45deg)",
    // @ts-ignore
    boxShadow: "0px 0px 2px 0px rgba(0, 0, 0, 0.12)"
};
const rightTopArrowStyles = {
    top: 0,
    right: 0,
    // @ts-ignore
    borderTopRightRadius: "1px",
    transform: "translateX(40%) translateY(10px) rotate(45deg)",
    // @ts-ignore
    boxShadow: "0px 0px 2px 0px rgba(0, 0, 0, 0.12), 1px -1px 4px 0px rgba(0, 0, 0, 0.10)"
};
const rightCenterArrowStyles = {
    top: "50%",
    right: 0,
    transform: "translate(40%, -50%) rotate(45deg)",
    // @ts-ignore
    borderTopRightRadius: "1px",
    transformOrigin: "center center",
    // @ts-ignore
    boxShadow: "0px 0px 2px 0px rgba(0, 0, 0, 0.12), 1px -1px 4px 0px rgba(0, 0, 0, 0.10)"
};
const rightBottomArrowStyles = {
    bottom: 0,
    right: 0,
    // @ts-ignore
    borderTopRightRadius: "1px",
    transform: "translateX(40%) translateY(-10px) rotate(45deg)",
    // @ts-ignore
    boxShadow: "0px 0px 2px 0px rgba(0, 0, 0, 0.12), 1px -1px 4px 0px rgba(0, 0, 0, 0.10)"
};
const bottomStartArrowStyles = {
    bottom: 0,
    left: 0,
    // @ts-ignore
    borderBottomRightRadius: "1px",
    transform: "translateY(40%) translateX(10px) rotate(45deg)",
    // @ts-ignore
    boxShadow: "0px 0px 2px 0px rgba(0, 0, 0, 0.12), 4px 4px 4px 0px rgba(0, 0, 0, 0.10)"
};
const bottomCenterArrowStyles = {
    bottom: 0,
    left: "50%",
    transform: "translate(-50%, 40%) rotate(45deg)",
    // @ts-ignore
    borderBottomRightRadius: "1px",
    transformOrigin: "center center",
    // @ts-ignore
    boxShadow: "0px 0px 2px 0px rgba(0, 0, 0, 0.12), 4px 4px 4px 0px rgba(0, 0, 0, 0.10)"
};
const bottomEndArrowStyles = {
    bottom: 0,
    right: 0,
    // @ts-ignore
    borderBottomRightRadius: "1px",
    transform: "translateY(40%) translateX(-10px) rotate(45deg)",
    // @ts-ignore
    boxShadow: "0px 0px 2px 0px rgba(0, 0, 0, 0.12), 4px 4px 4px 0px rgba(0, 0, 0, 0.10)"
};
const arrowStylesMap = {
    "left-top": leftTopArrowStyles,
    "left-center": leftCenterArrowStyles,
    "left-bottom": leftBottomArrowStyles,
    "top-start": topStartArrowStyles,
    "top-center": topCenterArrowStyles,
    "top-end": topEndArrowStyles,
    "right-top": rightTopArrowStyles,
    "right-center": rightCenterArrowStyles,
    "right-bottom": rightBottomArrowStyles,
    "bottom-start": bottomStartArrowStyles,
    "bottom-center": bottomCenterArrowStyles,
    "bottom-end": bottomEndArrowStyles
};
const tooltipPositionStyles = {
    "left-top": {
        left: "100%",
        top: "50%",
        transform: "translate(10px, -18px)"
    },
    "left-center": {
        left: "100%",
        top: "50%",
        transform: "translate(10px, -50%)"
    },
    "left-bottom": {
        left: "100%",
        bottom: "50%",
        transform: "translate(10px, 18px)"
    },
    "top-start": {
        left: "50%",
        top: "100%",
        transform: "translate(-18px, 10px)"
    },
    "top-center": {
        left: "50%",
        top: "100%",
        transform: "translate(-50%, 10px)"
    },
    "top-end": {
        right: "50%",
        top: "100%",
        transform: "translate(18px, 10px)"
    },
    "right-top": {
        right: "100%",
        top: "50%",
        transform: "translate(-10px, -18px)"
    },
    "right-center": {
        right: "100%",
        top: "50%",
        transform: "translate(-10px, -50%)"
    },
    "right-bottom": {
        right: "100%",
        bottom: "50%",
        transform: "translate(-10px, 18px)"
    },
    "bottom-start": {
        left: "50%",
        bottom: "100%",
        transform: "translate(-18px, -10px)"
    },
    "bottom-center": {
        left: "50%",
        bottom: "100%",
        transform: "translate(-50%, -10px)"
    },
    "bottom-end": {
        right: "50%",
        bottom: "100%",
        transform: "translate(18px, -10px)"
    }
};
const getTooltipStyles = (arrowPosition) => (Object.assign(Object.assign({}, tooltipPositionStyles[arrowPosition]), { borderRadius: "radius-2", 
    // @ts-ignore
    boxShadow: "0px 0px 2px 0px rgba(0, 0, 0, 0.12), 1px 4px 4px 0px rgba(0, 0, 0, 0.10)", position: "absolute", zIndex: "dropdown", 
    // @ts-ignore
    maxWidth: "320px", width: "max-content", "::before": Object.assign({ content: '""', position: "absolute", width: "spacing-5", height: "spacing-5", backgroundColor: "white" }, arrowStylesMap[arrowPosition]) }));
exports.getTooltipStyles = getTooltipStyles;
//# sourceMappingURL=TooltipStyles.js.map